import { CREATE_USER_FORM_FABRIC_REPORTS, FETCH_FABRIC_REPORT_DATA_FAILURE, FETCH_FABRIC_REPORT_DATA_REQUEST, FETCH_FABRIC_REPORT_DATA_SUCCESS } from "./fabricReport.actionType";



export const FABRIC_REPORT = 'fabricReport'


let initialState = {
    loading: false,
    fabricReportData: [],
    userform: {
        fldFKUnitId: -1,
        // fldStartDate: new Date().setDate(new Date().getDate() - 15),
        fldStartDate: new Date(),
        fldEndDate: new Date(),
        fldId: -1
    },
};

export let fabricReportReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_FABRIC_REPORT_DATA_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case FETCH_FABRIC_REPORT_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricReportData: updatePayload,
            };

        case CREATE_USER_FORM_FABRIC_REPORTS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };

        case FETCH_FABRIC_REPORT_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        default:
            return state;
    }
};